import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from './pages/Header';
import { Seo } from './Seo';
import { SiteFooter } from './visualComponent/SiteFooter';
import './../css/CookiePolicyPage.css';

// Technical cookie rows (names/durations static; purpose prose from i18n).
const ROWS = {
  necessary: [
    { cookie: '__cf_bm', provider: 'Cloudflare Turnstile', duration: '30 min' },
    { cookie: 'cf_clearance', provider: 'Cloudflare', duration: '≤ 1 yr' },
    { cookie: 'aby-cookie-consent', provider: 'abyfoods.fi (local storage)', duration: '—' },
  ],
  analytics: [
    { cookie: '_ga', provider: 'Google Analytics 4', duration: '2 yrs' },
    { cookie: '_ga_XHGGE7V3V9', provider: 'Google Analytics 4', duration: '2 yrs' },
  ],
};

export const CookiePolicyPage = () => {
  const { t } = useTranslation('global');

  const Section = ({ k }) => (
    <section className="cookie-policy-section">
      <h2>{t(`cookies.policy.${k}.heading`)}</h2>
      <p>{t(`cookies.policy.${k}.body`)}</p>
    </section>
  );

  return (
    <>
      <Seo pageKey="cookies" sub="cookies" />
      <Header />
      <main className="cookie-policy">
        <h1>{t('cookies.policy.title')}</h1>

        <Section k="intro" />
        <Section k="usage" />

        <section className="cookie-policy-section">
          <h2>{t('cookies.policy.table.heading')}</h2>
          <table className="cookie-policy-table">
            <thead>
              <tr>
                <th>{t('cookies.policy.table.colCookie')}</th>
                <th>{t('cookies.policy.table.colProvider')}</th>
                <th>{t('cookies.policy.table.colPurpose')}</th>
                <th>{t('cookies.policy.table.colDuration')}</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.necessary.map((r, i) => (
                <tr key={r.cookie}>
                  <td><code>{r.cookie}</code></td>
                  <td>{r.provider}</td>
                  {i === 0 && <td rowSpan={ROWS.necessary.length}>{t('cookies.policy.table.necessaryPurpose')}</td>}
                  <td>{r.duration}</td>
                </tr>
              ))}
              {ROWS.analytics.map((r, i) => (
                <tr key={r.cookie}>
                  <td><code>{r.cookie}</code></td>
                  <td>{r.provider}</td>
                  {i === 0 && <td rowSpan={ROWS.analytics.length}>{t('cookies.policy.table.analyticsPurpose')}</td>}
                  <td>{r.duration}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={2}>—</td>
                <td>{t('cookies.policy.table.marketingPurpose')}</td>
                <td>—</td>
              </tr>
            </tbody>
          </table>
        </section>

        <Section k="withdraw" />
        <Section k="controller" />

        <p className="cookie-policy-updated">{t('cookies.policy.updated')}</p>
      </main>
      <SiteFooter />
    </>
  );
};
